export default __webpack_public_path__ + "static/media/vincennes7.1bcf23a5.jpg";